<template>
  <div>
    <div class="col-12" v-if="!loading">
      <div class="form-row row form_padrao" v-if="!leadDetalhe">
        <div class="form-group flutuante col-md-4">
          <input
            type="text"
            name="pesquisa_leads"
            id="pesquisa_leads"
            v-model="filters['global']"
            required
            autocomplete="off"
          />
          <label for="pesquisa_leads">Pesquisar leads...</label>
        </div>
      </div>
      <div class="row" v-if="!leadDetalhe">
        <div class="col-md-12">
          <DataTable
            :selection.sync="selectedLead"
            selectionMode="single"
            :value="leads"
            class="p-datatable-striped p-datatable-responsive-demo"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]"
            :paginator="true"
            :filters="filters"
            data-key="id"
            @row-select="onRowSelect"
            currentPageReportTemplate="Exibindo {first} até {last} de {totalRecords}"
            :rows="10"
          >
            <template #header>
              <div class="table-header">
                <span class="p-input-icon-left form_padrao">
                  <div class="form-group flutuante col-md-6">
                    <input
                      type="text"
                      name="pesquisar"
                      id="pesquisar"
                      class="d-none"
                      required
                      v-model="filters['global']"
                      placeholder="Digite alguma coisa..."
                    />
                  </div>
                </span>
              </div>
            </template>
            <template #loading>Carregando a lista de leads...</template>
            <template #empty>Nenhum lead encontrado.</template>
            <Column field="id" header="ID" sortable></Column>
            <Column field="razao" header="Nome do Lead" sortable></Column>
            <Column field="data" header="Data" sortable>
              <template #body="slotProps">
                <span>{{ slotProps.data.data }}</span>
              </template>
            </Column>
            <Column field="status" header="Status" sortable>
              <template #body="slotProps">
                <span
                  :class="`${
                    slotProps.data.status == 'FECHADA PERDIDA'
                      ? 'badge badge-danger'
                      : 'badge badge-success'
                  }`"
                  >{{ slotProps.data.status }}</span
                >
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <div class="row" v-if="leadDetalhe">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <div>
            <i
              class="material-icons arrow pr-2"
              title="Voltar para lista de Leads"
              @click="leadDetalhe = ''"
              >keyboard_backspace</i
            >
            <h4 class="title">{{ leadDetalhe.razaO_SOCIAL_LEAD }}</h4>
          </div>
          <div>
            <button
              type="button"
              class="btn btn-azul p-2 fit-content fw-600"
              :disabled="loading"
              data-toggle="modal"
              data-target="#modalLead"
              @click="modalShow = true"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">Solicitando...</span>
              <span v-else>+ alterar status</span>
            </button>
          </div>
        </div>
        <div class="col-md-8 pt-3">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-end">
                <h4 class="d-flex align-items-center" style="font-weight: 600">
                  <i class="material-icons color-blue pr-1">person</i>
                  {{ leadDetalhe.nomE_CONTATO_LEAD }}
                </h4>
                <span
                  class="badge py-2"
                  :class="
                    leadDetalhe.status == 'Fechada_Perdida'
                      ? 'badge-danger'
                      : 'badge-success'
                  "
                  >{{ leadDetalhe.status.replace("_", " ") }}</span
                >
              </div>
              <hr class="divisor" />
              <div>
                <p class="py-1 small text-uppercase">
                  Abertura:
                  <span class="font-weight-bold">{{
                    leadDetalhe.abertura
                  }}</span>
                </p>
                <p class="py-1 small text-uppercase">
                  Código do sócio:
                  <span class="font-weight-bold">{{
                    leadDetalhe.codsociO_LEAD
                  }}</span>
                </p>
                <p class="py-1 small text-uppercase">
                  Parceiro:
                  <span class="font-weight-bold">{{
                    leadDetalhe.parceiro
                  }}</span>
                </p>
                <p class="py-1 small text-uppercase">
                  Telefone:
                  <span class="font-weight-bold">{{
                    leadDetalhe.telefonE_1_LEAD
                  }}</span>
                </p>
                <p class="py-1 small text-uppercase">
                  E-mail:
                  <span class="font-weight-bold">{{
                    leadDetalhe.emaiL_LEAD
                  }}</span>
                </p>
                <p class="py-1 small text-uppercase">
                  Documento:
                  <span class="font-weight-bold">{{
                    leadDetalhe.documentO_LEAD
                  }}</span>
                </p>
                <p class="pt-3">Descrição</p>
                <hr class="text-muted" />
                <p
                  class="small text-uppercase"
                  v-for="(el, index) in historico"
                  :key="index"
                >
                  <span>{{ el }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-else>
      <loading />
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalLead"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title d-flex justify-content-center align-itens-center"
              id="exampleModalLongTitle"
            >
              <i class="material-icons secondary">list</i> NOVO STATUS LEAD
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form class="form_padrao pt-2" action @submit.prevent="alterarStatus">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group flutuante col-md-12">
                  <select
                    name="mvTipo"
                    id="mvTipo"
                    v-model="lead.tipo"
                    required
                    placeholder="Selecione"
                  >
                    <option value selected disabled></option>
                    <option value="0">Em Atendimento</option>
                    <option value="1">Fechada Perdida</option>
                    <option value="2">Fechado Ganho</option>
                  </select>
                  <label for="mvTipo" v-if="!lead.tipo">Operação</label>
                </div>
                <div
                  class="form-group flutuante col-md-12"
                  v-if="lead.tipo == '2'"
                >
                  <money
                    name="valor"
                    id="valor"
                    v-model="lead.valor"
                    required
                    v-bind="money"
                  ></money>

                  <label for="valor"
                    >Valor <small class="small">(em R$)</small></label
                  >
                </div>
                <div class="form-group flutuante col-md-12">
                  <textarea
                    type="text"
                    name="razao"
                    id="razao"
                    v-model="lead.motivo"
                    required
                  ></textarea>
                  <label for="razao">Razão</label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-verde fit-content"
                :disabled="loading"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                <span v-if="loading">Solicitando...</span>
                <span v-else>Alterar status</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import "primevue/resources/themes/saga-green/theme.css";
import { formatDate } from "../../helpers";
import { Money } from "v-money";
export default {
  name: "Boleto",
  components: {
    DataTable,
    Column,
    Money,
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: true,
      },
      lead: {
        motivo: "",
        id: "",
        tipo: "",
        valor: "",
      },
      loading: true,
      boletos: "",
      selectedLead: null,
      leads: [],
      leadDetalhe: "",
      filters: {},
      produto: {
        nome: "CDL Parcerias",
        id: "cdl parcerias",
      },
      breadcrumb: [
        {
          nome: "CDL Parcerias",
          id: "cdl parcerias",
          link: "",
        },
      ],
      historico: [],
      idChamado: null,
      idStatus: null,
    };
  },
  methods: {
    alterarStatus() {
      this.loading = true;
      var url = "";

      switch (this.lead.tipo) {
        case "0":
          url = "/api/Ssm/AtualizarLeadsAssociadoEmAtendimento";
          break;
        case "1":
          url = "/api/Ssm/AtualizarLeadsAssociadoFechadaPerdida";
          break;
        case "2":
          url = "/api/Ssm/AtualizarLeadsAssociadoFechadoGanho";
          break;
      }

      this.$http
        .post(url, {
          motivo: `${this.lead.motivo} - valor: ${
            this.lead.valor ? this.lead.valor : ""
          }`,
          chamado: this.lead.id,
        })
        .then((response) => {
          this.loading = false;
          this.lead.valor = "";
          this.lead.motivo = "";
          this.lead.tipo = "";
          this.buscarDetalhe();
          document.getElementById("close").click();

          this.$toast.open({
            message: response.data.message,
            type: "success",
          });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.$toast.open({
            message: error,
            type: "error",
          });
        });
    },
    onRowSelect(event) {
      this.loading = true;
      this.lead.id = event.data.id.toString();
      this.idChamado = event.data.id.toString();
      this.idStatus = event.data.idstatus.toString();
      this.buscarDetalhe();
    },
    buscarDetalhe() {
      this.$http
        .post("/api/Ssm/DetalheLeadAssociado", {
          idchamado: this.idChamado,
          status: this.idStatus,
        })
        .then((response) => {
          this.loading = false;
          this.historico = [];
          this.leadDetalhe = response.data[0];
          response.data.forEach((el) => {
            this.historico.push(el.descricaO_ATIVIDADE);
          });
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.$http
      .get("/api/Ssm/ListarLeadsAssociado")
      .then((response) => {
        this.loading = false;
        response.data.map((e) => {
          e["data"] = formatDate(new Date(e.data));
        });
        if (!response.data[0].status) {
          this.leads = [];
        } else {
          this.leads = response.data;
        }
      })
      .catch((error) => {
        this.loading = false;
        console.error(error);
      });
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;
  small {
    line-height: 1.5rem;
  }
  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;
    background: #05428e;
    i {
      font-size: 13px;
      color: white;
    }
  }
  &:hover {
    transform: scale(1.05);
  }
}
</style>

<style lang="scss">
.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
// @media screen and (min-width: 901px) {
// .flutuante{
//   margin-left: -15px
// }
// }
@media screen and (max-width: 40em) {
  .p-datatable-responsive-demo {
    .p-datatable-thead > tr > th,
    .p-datatable-tfoot > tr > td {
      display: none !important;
    }

    .p-datatable-tbody > tr > td {
      text-align: left;
      display: block;
      width: 100%;
      float: left;
      clear: left;
      border: 0 none;

      .p-column-title {
        padding: 0.4rem;
        min-width: 30%;
        display: inline-block;
        margin: -0.4em 1em -0.4em -0.4rem;
        font-weight: bold;
      }

      &:last-child {
        border-bottom: 1px solid var(--surface-d);
      }
    }
  }
}

.title {
  font-weight: 600;
  color: #05428e;
  border-bottom: 2px solid #1aaa60;
  line-height: 2rem;
}
.arrow {
  font-size: 2rem;
  color: #1aaa60;
  cursor: pointer;
}
</style>
